export enum grantTypeDictionary {
  trackId = 'authorization_track_id',
  code = 'authorization_code',
  refresh = 'refresh_token',
}

export type TGrantType = grantTypeDictionary.trackId | grantTypeDictionary.code | grantTypeDictionary.refresh;
